export default __webpack_public_path__ + "static/media/loadmore.cd9fefe0.svg";